import React from 'react';

import PropTypes from 'prop-types';
import CloseButton from 'react-bootstrap/CloseButton';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';

import { productTitle } from '@src/components/products';

import '@src/components/common/Display/ResourceTooltip/ResourceTooltip.scss';

const getStatus = (stateId, availability, currentItem) => {
    if (availability) {
        const matched = availability.find((item) => (
            item.states && item.states.includes(stateId)
        ));
        if (matched) {
            return matched.title;
        }
    }

    if (currentItem?.map_available_states?.some((s) => s.abbreviation === stateId)) {
        return 'Available';
    }
    if (currentItem?.map_coming_soon_states?.some((s) => s.abbreviation === stateId)) {
        return 'Coming Soon';
    }
    if (currentItem?.map_relaunched_states?.some((s) => s.abbreviation === stateId)) {
        return 'Relaunched';
    }

    return 'Not Available / Limited';
};

const AvailibilityTooltip = (props) => {
    const {
        target,
        stateId,
        placement = 'top',
        currentItem,
        availability,
    } = props;

    const status = getStatus(stateId, availability, currentItem);

    return (
        <Overlay target={target} show={Boolean(stateId)} placement={placement}>
            {(overlayProps) => {
                return (
                    <Tooltip id="overlay-example" className="availability-map-tooltip" {...overlayProps}>
                        <CloseButton aria-label="Hide" />
                        {
                            currentItem
                                && (
                                    <div className="tool-tip-item-container">
                                        <span className="tooltip-header">
                                            { productTitle(currentItem) }
                                            <br />
                                            <span className="tooltip-available">
                                                { `${status} in ${stateId}` }
                                            </span>
                                        </span>
                                    </div>
                                )
                        }
                    </Tooltip>
                );
            }}
        </Overlay>
    );
};

AvailibilityTooltip.propTypes = {
    target: PropTypes.object.isRequired,
    stateId: PropTypes.string.isRequired,
    placement: PropTypes.string,
    currentItem: PropTypes.object.isRequired,
    availability: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        states: PropTypes.arrayOf(PropTypes.string),
    })),
};

export default React.memo(AvailibilityTooltip);
